import { Box, TableCell, Typography } from "@mui/material";
import { FirewatchChip } from "./FirewatchChip";
import { AggregateScoresNode } from "../FirewatchPage";
import { DynamicIcon } from "../icons/DynamicIcon";
import { ClampWithTooltip } from "~/components/ClampWithTooltip/ClampWithTooltip";
import { useFirewatchException } from "~/components/FirewatchRow/hooks/useFirewatchException";

export interface AdvisoryCellProps {
  row: AggregateScoresNode;
  isSmallTable?: boolean;
  title?: string;
  maxWidth?: number;
}

export function AdvisoryCell({
  row,
  isSmallTable,
  title,
  maxWidth,
}: AdvisoryCellProps) {
  const { tags } = row || {};
  const { hasException } = useFirewatchException({
    row,
  });

  return (
    <TableCell sx={isSmallTable ? { pl: "5px !important" } : { maxWidth }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <DynamicIcon iconId={row?.iconId} size={isSmallTable ? 18 : 24} />
        <ClampWithTooltip>
          <Typography
            sx={{
              fontSize: isSmallTable ? 12 : 14,
              fontWeight: isSmallTable ? 400 : 700,
              ml: 1,
              color: hasException ? "text.secondary" : "text.primary",
            }}
            data-testid="advisory-id"
          >
            {title || row?.title || row?.nodeTitle}
          </Typography>
        </ClampWithTooltip>
      </Box>

      {!isSmallTable && (
        <Box
          display="flex"
          gap={1}
          alignItems="center"
          mt={hasException || (tags?.length || 0) > 0 ? 1 : 0}
          sx={{
            overflowX: "scroll",
            scrollbarWidth: "none",
          }}
        >
          {(tags?.length || 0) > 0 && (
            <Box display="flex" gap={1}>
              {tags?.map((tag) => (
                <FirewatchChip
                  key={tag.key}
                  tag={tag}
                  inactive={hasException}
                />
              ))}
            </Box>
          )}
        </Box>
      )}
    </TableCell>
  );
}
